import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

export type GetPopularMarketplaceAssets = MarketplaceAssetType;
export type GetTopTenMarketplaceAssetsResponse = {
  marketplaceAssets: DefaultApiResponse<GetPopularMarketplaceAssets[]>;
};
type GetTopTenMarketplaceAssetsArgs = MarketplaceAdditionalArgs;

export const getTopTenMarketplaceAssetsQuery: TypedDocumentNode<
  GetTopTenMarketplaceAssetsResponse,
  DefaultArg & GetTopTenMarketplaceAssetsArgs
> = gql`
  query GetTop10MarketplaceAssets(
    $record: MarketplaceAssetsListRecord!
    $changeRecord: AssetsRateChangeRecord!
    $rateRecord: AssetsRateChangeRecord!
  ) {
    marketplaceAssets: getTop10MarketplaceAssets(record: $record) {
      change(record: $changeRecord)
      code
      iconUrl
      isFavorite
      name
      rate(record: $rateRecord)
      marketCap
    }
  }
`;
